import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class FormService {
  private ngselectData = new BehaviorSubject<any>(null);
  public selectData$ = this.ngselectData.asObservable();

  private modelData = new BehaviorSubject<any>(null);
  public modelData$ = this.modelData.asObservable();

  private formData = new BehaviorSubject<any>(null);
  public formData$ = this.formData.asObservable();

  private dataTable = new BehaviorSubject<any>(null);
  public dataTable$ = this.dataTable.asObservable();

  private loading = new BehaviorSubject<boolean>(false);
  public loading$ = this.loading.asObservable();

  private fields = new BehaviorSubject<FormlyFieldConfig[]>([]);

  fields$: Observable<FormlyFieldConfig[]> = this.fields.asObservable();
  form!: FormGroup;
  // ngSelectData: any;

  constructor() { }

  ngselectDataChange(data: any) {
    if (data) {
      // this.ngSelectData = data;
      this.ngselectData.next(data);
    } else {
      this.ngselectData.next(null);
      this.dataTable.next([]);
    }
  }

  setFormData(form: any) {
    this.form = form;
    this.formData.next(form);
  }

  setFields(fields: FormlyFieldConfig[]) {
    this.fields.next(fields);
  }

  setDataTable(data: any) {
    this.dataTable.next(data);
  }

  setLoadingState(state: boolean) {
    this.loading.next(state);
  }

  get fieldsValue(): FormlyFieldConfig[] {
    return this.fields.getValue();
  }
}
